import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useIsMount } from '@yme/hooks/useIsMount';
import { MOBILE_DROPDOWN_SLIDER_CLASS, PAGE_SCROLL_NOT_VISIBLE_TIME, PAGE_SCROLL_VISIBLE_TIME, } from './constants';
import { MobileDropdownContentStyled, MobileDropdownHeaderStyled, MobileDropdownSliderStyled, MobileSliderContainerStyled, MobileSliderTitle, OverlayStyled, TitleTextStyled, } from './styled';
export function MobileDropdownSlider({ children, isActive = false, maxHeight, handleActiveMobileSlider, callback, title, isRightToLeft, footerComponent, isResetContentPadding = false, isFooterColumn = false, isFullScreenHidden = false, }) {
    const [pageYCoordinate, setPageYCoordinate] = useState({
        startPageYCoordinate: 0,
        currentPageYCoordinate: 0,
    });
    const dropdownSliderRef = useRef(null);
    const isMount = useIsMount();
    const callbackHandler = useCallback(() => {
        if (callback) {
            setTimeout(() => {
                callback();
            }, PAGE_SCROLL_VISIBLE_TIME);
        }
    }, [callback]);
    const pageScrollVisible = (scrollType, time) => {
        const originalStyle = window.getComputedStyle(document.body).overflow;
        const timeoutId = setTimeout(() => {
            document.body.style.overflow = scrollType;
        }, time);
        return () => {
            clearTimeout(timeoutId);
            document.body.style.overflow = originalStyle;
        };
    };
    const cleanCoordinateValue = useCallback(() => {
        setPageYCoordinate({
            startPageYCoordinate: 0,
            currentPageYCoordinate: 0,
        });
    }, []);
    const onTouchStart = (event) => {
        const touchDown = event.touches[0].clientY;
        setPageYCoordinate({
            ...pageYCoordinate,
            startPageYCoordinate: touchDown + 20,
        });
    };
    const onTouchMove = (event) => {
        const currentTouch = event.touches[0].clientY;
        setPageYCoordinate({
            ...pageYCoordinate,
            currentPageYCoordinate: currentTouch,
        });
    };
    useEffect(() => {
        if (pageYCoordinate.startPageYCoordinate &&
            pageYCoordinate.startPageYCoordinate < pageYCoordinate.currentPageYCoordinate) {
            handleActiveMobileSlider(false);
            cleanCoordinateValue();
            callbackHandler();
        }
    }, [
        callbackHandler,
        cleanCoordinateValue,
        handleActiveMobileSlider,
        pageYCoordinate.currentPageYCoordinate,
        pageYCoordinate.startPageYCoordinate,
    ]);
    useEffect(() => {
        if (isMount)
            return;
        if (isActive) {
            return pageScrollVisible('hidden', PAGE_SCROLL_NOT_VISIBLE_TIME);
        }
        else {
            callbackHandler();
            return pageScrollVisible('auto', PAGE_SCROLL_VISIBLE_TIME);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [callbackHandler, isActive]);
    return (React.createElement("div", null,
        React.createElement(OverlayStyled, { isActive: isActive, onClick: () => {
                handleActiveMobileSlider(false);
                callbackHandler();
            } }),
        React.createElement(MobileDropdownSliderStyled, { ref: dropdownSliderRef, isRightToLeft: isRightToLeft, isActive: isActive, isFullScreenHidden: isFullScreenHidden, onTouchMove: onTouchMove, onTouchEnd: cleanCoordinateValue, className: MOBILE_DROPDOWN_SLIDER_CLASS },
            React.createElement(MobileSliderContainerStyled, null,
                React.createElement(MobileDropdownHeaderStyled, { onTouchStart: onTouchStart }),
                title && (React.createElement(MobileSliderTitle, null,
                    React.createElement(TitleTextStyled, null, title))),
                Boolean(children) && (React.createElement(MobileDropdownContentStyled, { titleExist: Boolean(title), maxHeight: maxHeight, isVisibleModalWindowFooter: Boolean(footerComponent), isFooterColumn: isFooterColumn, isResetContentPadding: isResetContentPadding }, children)),
                footerComponent && footerComponent))));
}
